import React, { useMemo } from 'react';
import { T } from '@colonist/ui';
import { RegionSelectField } from './RegionSelectField/RegionSelectField.tsx';
import { getContinents, getCountriesOfContinent, getRegionsOfCountry } from './utils.ts';
import styles from './RegionChangeForm.module.scss';
/** Cascading continent/country/region selector for the profile region-change popup. */ export const RegionChangeForm = ({ regions: allRegions, selection, onSelectionChange })=>{
    const continents = useMemo(()=>getContinents(allRegions), [
        allRegions
    ]);
    const countries = useMemo(()=>getCountriesOfContinent(allRegions, selection.continentCode), [
        allRegions,
        selection.continentCode
    ]);
    const regions = useMemo(()=>getRegionsOfCountry(allRegions, selection.countryCode), [
        allRegions,
        selection.countryCode
    ]);
    const onContinentChange = (value)=>onSelectionChange({
            continentCode: value,
            countryCode: '',
            regionCode: ''
        });
    const onCountryChange = (value)=>onSelectionChange({
            continentCode: selection.continentCode,
            countryCode: value,
            regionCode: ''
        });
    const onRegionChange = (value)=>onSelectionChange({
            continentCode: selection.continentCode,
            countryCode: selection.countryCode,
            regionCode: value
        });
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.regionChangeForm
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.changeRegion.body'
        }
    })), /*#__PURE__*/ React.createElement(RegionSelectField, {
        label: {
            key: 'strings:colonistCommon.continent'
        },
        value: selection.continentCode,
        onSelect: onContinentChange
    }, [
        /*#__PURE__*/ React.createElement("option", {
            key: "placeholder",
            value: ""
        }),
        ...continents.map(({ code, name })=>/*#__PURE__*/ React.createElement("option", {
                key: code,
                value: code
            }, name))
    ]), /*#__PURE__*/ React.createElement(RegionSelectField, {
        label: {
            key: 'strings:colonistCommon.country'
        },
        value: selection.countryCode,
        onSelect: onCountryChange
    }, [
        /*#__PURE__*/ React.createElement("option", {
            key: "placeholder",
            value: ""
        }, /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:popups.changeRegion.doNotDisplay'
            }
        })),
        ...countries.map(({ code, name })=>/*#__PURE__*/ React.createElement("option", {
                key: code,
                value: code
            }, name))
    ]), /*#__PURE__*/ React.createElement(RegionSelectField, {
        label: {
            key: 'strings:colonistCommon.region'
        },
        value: selection.regionCode,
        onSelect: onRegionChange
    }, [
        /*#__PURE__*/ React.createElement("option", {
            key: "placeholder",
            value: ""
        }, /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:popups.changeRegion.doNotDisplay'
            }
        })),
        ...regions.map((r)=>/*#__PURE__*/ React.createElement("option", {
                key: r.regionCode,
                value: r.regionCode
            }, r.regionName))
    ]));
};
